import React  from 'react';
  
//../../shared/constants/AppConst
export const siteSettingsListConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/manage-disorder',
        component: React.lazy(() => import('./SiteSettingTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/manage-gp',
        component: React.lazy(() => import('./ManageGpSettingTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/signposting',
        component: React.lazy(() => import('./ManageSignPostingSettingTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/handbook',
        component: React.lazy(() => import('./ManageHandbookSettingTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/manage-documents',
        component: React.lazy(() => import('./ManageLeafletsSettingTabs')),
      },
    ],
  }
  
];
